import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { OrderService } from '@app/shared/services/order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';
import { Router } from '@angular/router';
import { JssService } from '@app/shared/services/jss.service';
import { MatMixService } from '@app/shared/services/mat-mix.service';
import { MatAllotService } from '@app/shared/services/mat-allot.service';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-unsaved-order',
  templateUrl: './unsaved-order.component.html',
  styleUrls: ['./unsaved-order.component.css']
})
export class UnsavedOrderComponent implements OnInit {

  orderList: any[] = [];
  FullorderList: any[] = [];
  selectedStatus: string = ''; // Default to "New Orders"
  fromDate: string = ''; // Start date for filtering
toDate: string = '';   // End date for filtering

  // selectedStatus: string = 'MatProcessAllocated'; // Default to "New Orders"

  // Use a private property to hold total items
  private _totalItems: number = 0;
  currentPage: number = 1;
  displayedUsers: any[] = [];
  itemsPerPage: number = 15;
  searchText: string = '';
  selectedOrder: any;
  orderId: string;
  disableBtn: Boolean;
  mathLib: any = Math;
  matArray: any[] = []; // Assuming matArray will hold data fetched from MatMixService
  clientName: string = ''; //for filter
  refNo: string = '';
  
  unsavedOrderForm = this.formBuilder.group({
    jssId: [{ value: '', disabled: true }, [Validators.required]],
    ticketno: [{ value: '', disabled: true }, [Validators.required]],
    clientName: [{ value: '', disabled: true }, [Validators.required]],
    refNo: [{ value: '', disabled: true }, [Validators.required]],
    poNo: [{ value: '', disabled: true }, [Validators.required]],
    jobName: [{ value: '', disabled: true }, [Validators.required]],
    jobType: [{ value: '', disabled: true }, [Validators.required]],
    orderKgs: [{ value: '', disabled: true }, [Validators.required]],
    LamType: [{ value: '', disabled: true }, [Validators.required]], // Lam Type control
    jssfolderno:[{ value: '', disabled: true }, [Validators.required]], // Lam Type control
    location:[{ value: '', disabled: true }, [Validators.required]],
    circumference:[{ value: '', disabled: true }, [Validators.required]],
    length: [{ value: '', disabled: true }, [Validators.required]],
    barcode: [{ value: '', disabled: true }, [Validators.required]],
    Process1: ['NaN', Validators.required],
    Process2: ['NaN', Validators.required],
    Process3: ['NaN', Validators.required],
    Process4: ['NaN', Validators.required],
    Process5: ['NaN', Validators.required],
    Process6: ['NaN', Validators.required],
    material1: ['NaN', Validators.required],
    material2: ['NaN', Validators.required],
    material3: ['NaN', Validators.required],
    material4: ['NaN', Validators.required],
    material5: ['NaN', Validators.required],
    material6: ['NaN', Validators.required],
    matSize1: ['0', Validators.required],
    matSize2: ['0', Validators.required],
    matSize3: ['0', Validators.required],
    matSize4: ['0', Validators.required],
    matSize5: ['0', Validators.required],
    matSize6: ['0', Validators.required],
    thickness1: ['0', Validators.required],
    thickness2: ['0', Validators.required],
    thickness3: ['0', Validators.required],
    thickness4: ['0', Validators.required],
    thickness5: ['0', Validators.required],
    thickness6: ['0', Validators.required],
    matReq1: ['0', Validators.required],
    matReq2: ['0', Validators.required],
    matReq3: ['0', Validators.required],
    matReq4: ['0', Validators.required],
    matReq5: ['0', Validators.required],
    matReq6: ['0', Validators.required],
   
    printType: [{ value: '', disabled: true }, [Validators.required]], // Print Type control
    printDirection: [{ value: '', disabled: true }, [Validators.required]], // Print Dir control
    std: [{ value: '', disabled: true }, [Validators.required]], // std control
    liquid: [{ value: '', disabled: true }, [Validators.required]], // Liquid Ink control
    inkType: [{ value: '', disabled: true }, [Validators.required]], // Inktype control
    nco: [''], // Adhesive control
    oh: [''], // Adhesive control
    coilWidth: [{ value: '', disabled: true }, [Validators.required]], // Coil Width control
    coilod: [{ value: '', disabled: true }, [Validators.required]], // Coilod control
    fdOption: [{ value: '', disabled: true }, [Validators.required]], // Final Direction control
    packageType: [{ value: '', disabled: true }, [Validators.required]], // Packaging Type control
    pouch: [{ value: '', disabled: true },], // POUCH control
    orderPcs: [{ value: '', disabled: true },],
    gram:  [{ value: '', disabled: true },],
    remark: [{ value: '', disabled: true }, [Validators.required]], // REMARKS control
    date1: ['', [Validators.required]], // Delivery Date control
    created: [{ value: '', disabled: true }, [Validators.required]], // Order Date control
    colorNumber: [{ value: '', disabled: true }, [Validators.required]],
    colorNames: [{ value: '', disabled: true }, [Validators.required]], // COLORS control
    gluing: [''], // Gluing Rolls control
    coreType: ['', [Validators.required]], // Rolls Width control
    cutting: [''], // Cutting Size control
    prepared: ['', [Validators.required]], // Prepared by control
    approved: ['', [Validators.required]], // Approved by control
    id: ['', [Validators.required]],
    supplier: ['', [Validators.required]],
    repeatLength: ['', [Validators.required]],
    totalGsm:['']
   // repeatedStatus: [''], // Add this line
  });
  
  constructor(private formBuilder: FormBuilder,
    private orderService: OrderService,
    private matMixService: MatMixService,
    private jss: JssService,private repeated: RepeatOrderService,
    private activatedRoute: ActivatedRoute,private router: Router,private matAllotService: MatAllotService,
    private unsavedOrder: OrderDataService, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
      console.log('URL Params:', this.activatedRoute.snapshot.params);
      this.getConfirmedOrders();
      
      this.activatedRoute.params.subscribe((params) => {
        console.log('Route Params:', params);
        const orderId = params['id'];
        if (orderId) {
          this.orderId = orderId;
          this.updateOrder(this.orderId);
          this.showTable = false;
          setTimeout(() => {
            this.unsavedOrderForm.disable();
            
            console.log(this.unsavedOrderForm.controls['date1'].value)
            if(!this.unsavedOrderForm.controls['date1'].value || this.unsavedOrderForm.controls['date1'].value == 'NaN-aN-aN')
              this.unsavedOrderForm.controls['date1'].enable();

            if(!this.unsavedOrderForm.controls['gluing'].value)
              this.unsavedOrderForm.controls['gluing'].enable();

            if(!this.unsavedOrderForm.controls['cutting'].value)
              this.unsavedOrderForm.controls['cutting'].enable();

            if(!this.unsavedOrderForm.controls['nco'].value)
              this.unsavedOrderForm.controls['nco'].enable();
            if(!this.unsavedOrderForm.controls['oh'].value)
              this.unsavedOrderForm.controls['oh'].enable();
            if(!this.unsavedOrderForm.controls['prepared'].value)
              this.unsavedOrderForm.controls['prepared'].enable();
            
            if(!this.unsavedOrderForm.controls['approved'].value)
              this.unsavedOrderForm.controls['approved'].enable();
          }, 500);
        } else {
          // console.error('OrderId is undefined or null in route parameters.');
        }
      });
      this.getMat(this.orderId);
      //this.getRepeatOrderDetails(this.orderId);
    }
    updateOrder(orderId: string) {
      this.jss.getJssById(orderId).subscribe(
        (res: any) => {
          this.unsavedOrderForm.patchValue({
            jssId:res._id,
            clientName: res.clientName,
            ticketno: res.ticketno,
            poNo: res.poNo,
            totalGsm:res. totalGsm,
            refNo: res.refNo,
            created: this.formatDate(res.created),
            jobName:res.jobName ,
            LamType:res.LamType ,
            jobType:res.jobType ,
            orderKgs :res.orderKgs,
            jssfolderno: res.jssfolderno,
            std: res.std,
            location: res.cylinders.location,
            length: res.cylinders.length,
            circumference: res.cylinders.circumference,
            id: res.cylinders.id,
            supplier: res.cylinders.supplier,
            coilWidth:res.coilWidth,
            coreType:res.coreType,
            repeatLength:res.repeatLength,
            coilod:res.coilod,
            pouch:res.pouch,
            barcode:res.barcode,
            liquid:res.liquid,
            inkType:res.inkType,
            fdOption:res.fdOption,
            packageType:res.packageType,
            remark:res.remark,
            colorNames:res.colorNames,
            colorNumber:res.colorNumber,
            printType:res.printType,
            printDirection:res.printDirection,
            // approved:res.approved,
            date1: res.ddDate,
            // gluing:res.gluing,
            // prepared:res.prepared,
            // cutting:res.cutting
          });
          if(res.date1 && res.prepared && res.approved)
              this.disableBtn = true;
     
        },
        (err: any) => {
          console.log(err);
        }
      );
    }

    getMat(orderId: string) {
      this.matMixService.getAllMatMix().subscribe(
          (matMixResponse: any[]) => {
              const orderDetails = matMixResponse.find(item => item.orderId === orderId);
              console.log(orderDetails);
              
              if (orderDetails && orderDetails.Materials) {
                  orderDetails.Materials.forEach((material, index) => {
                      if (index < 6) { // Assuming you only want to patch the first 6 materials
                          this.unsavedOrderForm.patchValue({
                              [`Process${index + 1}`]: material.process,
                              [`material${index + 1}`]: material.material,
                              [`thickness${index + 1}`]: material.thickness,
                              [`matSize${index + 1}`]: material.width, // Adjust if needed
                              [`matReq${index + 1}`]: material.matRequired, // Adjust if needed
                              // Add any other mappings if necessary
                          });
                      }
                  });
              }
          },
          (err: any) => {
              console.error('Error fetching matMix:', err);
          }
      );
  }
  
  getConfirmedOrders() {
    // Fetch JSS data first
    this.unsavedOrder.getAllUnsavedOrders().subscribe(
      (jssList: any[]) => {
        // Once JSS data is fetched, fetch confirmed orders
        this.jss.getJssList().subscribe(
          (confirmedOrders: any[]) => {
            // Filter confirmed orders where status is "MatAllocated"
            const filteredOrders = confirmedOrders.filter(order => order.status === "MatAllocated");
  
            // Collect IDs of orders that have the status "ticketGenerated"
            const ticketGeneratedIds = new Set(
              jssList
                .filter(jss => jss.status === "ticketGenerated")
                .map(jss => jss.jssId) // Make sure to use the correct field here
            );

            // Remove orders from the list if their ID is in the ticketGenerated list
            this.orderList = filteredOrders.filter(order => !ticketGeneratedIds.has(order._id));
  // Reverse the orderList
  this.orderList.reverse();

            this.cdr.detectChanges(); // Trigger change detection
          },
          (err: any) => {
            console.log(err);
          }
        );
      },
      (err: any) => {
        console.log(err);
      }
    );
}


  filterOrders() {
    this.orderList = this.FullorderList.filter(order => {
        const orderDate = new Date(order.created); // Use 'created' date for filtering
  
        // Check if the order status matches the selected status
        const statusMatches = (this.selectedStatus === 'MatAllocated' && order.status === 'MatAllocated') ||
        (this.selectedStatus === '');
                              // (this.selectedStatus === 'Repeated Order' && order.status === 'Repeated Order') ||
                            
  
        // Check if the order date is within the selected range
        const fromDateMatches = this.fromDate ? orderDate >= new Date(this.fromDate) : true;
        const toDateMatches = this.toDate ? orderDate <= new Date(this.toDate) : true;
  
        // Check if client name matches
        const clientNameMatches = this.clientName ? order.clientName.toLowerCase().includes(this.clientName.toLowerCase()) : true;
  
        // Check if reference number matches
        const refNoMatches = this.refNo ? order.refNo.toLowerCase().includes(this.refNo.toLowerCase()) : true;
  
        return statusMatches && fromDateMatches && toDateMatches && clientNameMatches && refNoMatches; // Combine all conditions
    });
  
    // Sort the filtered list
    this.orderList.sort((a, b) => {
        if (a.status === 'MatAllocated' && b.status !== 'MatAllocated') {
            return -1; // a comes first
        }
        if (a.status !== 'MatAllocated' && b.status === 'MatAllocated') {
            return 1; // b comes first
        }
        // if (a.status === 'Repeated Order' && b.status !== 'Repeated Order') {
        //     return -1; // a comes first
        // }
        // if (a.status !== 'Repeated Order' && b.status === 'Repeated Order') {
        //     return 1; // b comes first
        // }
        return 0; // keep original order for other statuses
    });
  
    this._totalItems = this.orderList.length; // Update total items after filtering and sorting
  }

  
  showTable = true;
  formData: any = {};

  toggleView() {
    this.showTable = !this.showTable;
    this.formData = {};
  }

 
  saveOrder() {
    this.showTable = false;
    this.formData = {};
  }
  
 
 

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
  
    return `${year}-${month}-${day}`;
  }

 
  userData = new FormData();

  submitForm(): void {
    if (this.unsavedOrderForm.valid) { // Check if the form is valid
      const formData = {};
      Object.keys(this.unsavedOrderForm.controls).forEach((key) => {
        formData[key] = this.unsavedOrderForm.get(key)?.value;
      });

          // Check if both approved and prepared fields are filled
          if (formData['approved'] && formData['prepared']) {
            formData['status'] = 'ticketGenerated';
    
            // Call UnsavedOrder API to submit the form
            this.unsavedOrder.UnsavedOrder(formData, this.orderId).subscribe(
              (res: any) => {
                console.log('Unsaved order response:', res);
    
                // Clear the form data after successful submission
                this.unsavedOrderForm.reset();
                this.router.navigate(['/printTicket']);
              },
              (err: any) => {
                console.error('Error saving unsaved order:', err);
                // Handle the error in the UI or take appropriate action
              }
            );
          } else {
            // Reset missingFields array
            let missingFields = [];
    
            // Identify missing fields
            Object.keys(this.unsavedOrderForm.controls).forEach(key => {
              const control = this.unsavedOrderForm.get(key);
              if (control && control.invalid) {
                // Check if the control is required and not filled
                if (control.errors?.required) {
                  missingFields.push(key);
                }
              }
            });
    
            // Highlight missing fields in red
            missingFields.forEach(field => {
              this.unsavedOrderForm.get(field)?.setErrors({ 'highlight': true });
            });
    
            // Display an alert to inform the user about the required fields
            alert('Please fill in all required fields before submitting.');
          }
        } else {
          // Mark all form controls as touched to trigger validation messages
          this.markFormGroupTouched(this.unsavedOrderForm);
    
          // Display an alert to inform the user about the required fields
          alert('Please fill in all required fields before submitting.');
        }
      }
    
      markFormGroupTouched(formGroup: FormGroup) {
        Object.values(formGroup.controls).forEach(control => {
          control.markAsTouched();
          if (control instanceof FormGroup) {
            this.markFormGroupTouched(control);
          }
        });
      }
  

get paginatedClients(): any[] {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  return this.orderList
    .filter((client) => this.matchesSearch(client))
    .slice(startIndex, endIndex);
}

getNumberRange(end: number): number[] {
  return Array.from({ length: end }, (_, index) => index + 1);
}

ceil(value: number): number {
  return Math.ceil(value);
}

get totalItems(): number {
  return this._totalItems;
}

calculateRangeStart(): number {
  return (this.currentPage - 1) * this.itemsPerPage + 1;
}

calculateRangeEnd(): number {
  return Math.min(this.currentPage * this.itemsPerPage, this._totalItems);
}

onPageChange(page: number): void {
  // if (page >= 1 && page <= Math.ceil(this.totalItems / this.itemsPerPage)) {
    this.currentPage = page;
    this.updateDisplayedUsers();
  // }
}
getPages(): number[] {
  const totalPages = this.mathLib.ceil(this.totalItems / this.itemsPerPage);
  return Array.from({ length: totalPages }, (_, index) => index + 1);
}
updateDisplayedUsers() {
  const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  const endIndex = startIndex + this.itemsPerPage;
  this.orderList = this.FullorderList.slice(startIndex, endIndex);
}

onSearch(): void {
  this.currentPage = 1; // Reset to the first page when performing a new search
}

private matchesSearch(client: any): boolean {
  const searchFields = ['clientName', 'email', 'contactNo'];
  const lowerCaseSearch = this.searchText.toLowerCase();

  return searchFields.some((field) => {
    const fieldValue = client[field];
    if (fieldValue && typeof fieldValue === 'string') {
      return fieldValue.toLowerCase().includes(lowerCaseSearch);
    }
    return false;
  });
}

  deleteSelectedEntries() {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    const selectedIds = [];
    
    checkboxes.forEach((checkbox) => {
      if ((checkbox as HTMLInputElement).checked) {
        selectedIds.push((checkbox as HTMLInputElement).dataset.id); // Assuming dataset.id is used for ID
      }
    });

    if (selectedIds.length > 0) {
      this.jss.deleteAllJss(selectedIds).subscribe(
        (response) => {
          console.log('Entries deleted successfully:', response);
          // Optionally update your client list after deletion
          this.getConfirmedOrders(); // Example method to fetch clients again
        },
        (error) => {
          console.error('Error deleting entries:', error);
          // Handle error in UI or show error message
        }
      );
    } else {
      console.log('No entries selected for deletion');
      // Handle case where no entries are selected
    }
  }

  selectAllChanged(event: Event) {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    checkboxes.forEach((checkbox) => {
      (checkbox as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
    });
  }
}




  
// filterOrders() {
//   this.orderList = this.FullorderList.filter(order => {
//       const orderDate = new Date(order.created); // Use 'created' date for filtering

//       // Check if the order status matches the selected status
//       const statusMatches = (this.selectedStatus === 'MatProcessAllocated' && order.status === 'MatProcessAllocated') ||
//                             (this.selectedStatus === 'Repeated Order' && order.status === 'Repeated Order') ||
//                             (this.selectedStatus === '');

//       // Check if the order date is within the selected range
//       const fromDateMatches = this.fromDate ? orderDate >= new Date(this.fromDate) : true;
//       const toDateMatches = this.toDate ? orderDate <= new Date(this.toDate) : true;

//       return statusMatches && fromDateMatches && toDateMatches; // Combine all conditions
//   });

//   // Sort the filtered list to show "MatProcessAllocated" first, then "Repeated Orders"
//   this.orderList.sort((a, b) => {
//       if (a.status === 'MatProcessAllocated' && b.status !== 'MatProcessAllocated') {
//           return -1; // a comes first
//       }
//       if (a.status !== 'MatProcessAllocated' && b.status === 'MatProcessAllocated') {
//           return 1; // b comes first
//       }
//       if (a.status === 'Repeated Order' && b.status !== 'Repeated Order') {
//           return -1; // a comes first
//       }
//       if (a.status !== 'Repeated Order' && b.status === 'Repeated Order') {
//           return 1; // b comes first
//       }
//       return 0; // keep original order for other statuses
//   });

//   this._totalItems = this.orderList.length; // Update total items after filtering and sorting
// }



  
   
// submitForm(): void {
//   if (this.unsavedOrderForm) {
//     console.log(this.unsavedOrderForm);
//     const formData = {};
//     Object.keys(this.unsavedOrderForm.controls).forEach((key) => {
//       formData[key] = this.unsavedOrderForm.get(key)?.value;
//     });


//     // Check if both approve and prepare fields are filled
//     if (formData['approved'] && formData['prepared']) {
//       // Update the status to 'ticketGenerated'
//       formData['status'] = 'ticketGenerated';

//       // Call UnsavedOrder APIprintTicket
//       this.unsavedOrder.UnsavedOrder(formData).subscribe(
//         (res: any) => {
//           console.log('Unsaved order response:', res);

//               // Clear the form data after successful submission
//               this.unsavedOrderForm.reset();
//               this.router.navigate(['/printTicket']);
//         },
//         (err: any) => {
//           console.error('Error saving unsaved order:', err);
//           // Handle the error in the UI or take appropriate action
//         }
//       );
//     } else {
//       // Handle the case where both "approve" and "prepare" fields are not filled
//       console.log('Please fill in both "approve" and "prepare" fields to generate a ticket.');
//     }
//   }
// }

// filterPagOrder(users: any[]): any[] {
//   return users.filter(user =>
//       // user.Customer_Name.toLowerCase().includes(this.searchText.toLowerCase()) &&
//       this.isDateInRange(user.orderDate, this.fromDate, this.toDate) &&
//       user.refNo.toLowerCase().includes(this.refNo.toLowerCase()) &&
//       (this.selectedOrder === '' || user.Customer_Name === this.selectedOrder)
//   );
// }

  // getConfirmedOrders() {
  //   // Fetch orders from JSS and unsaved orders
  //   const jssCreatedOrders$ = this.jss.getJssList();
  //   const unsavedOrders$ = this.unsavedOrder.getAllUnsavedOrders();
  
  //   forkJoin([jssCreatedOrders$, unsavedOrders$]).subscribe(
  //     ([jssCreatedOrders, unsavedOrders]: [any[], any[]]) => {
  //       // Filter for orders with 'MatAllocated' status
  //       this.FullorderList = [
  //         ...jssCreatedOrders.filter((order: any) => order.status === 'MatAllocated'),
  //       ];
  
  //       // Reverse the list if needed
  //       this.orderList = this.FullorderList.reverse();
  
  //       // Debugging: Log the current orderId and unsaved orders
  //       console.log('Current Order ID:', this.orderId);
  //       console.log('Unsaved Orders:', unsavedOrders);
  
  //       // Check if the orderId has a corresponding unsaved order with 'ticketGenerated' status
  //       if (this.orderId) {
  //         const unsavedOrderToCheck = unsavedOrders.find(order => order.jssId === this.orderId);
  //         console.log('Unsaved Order to Check:', unsavedOrderToCheck);
  
  //         // If found and the status is 'ticketGenerated', remove it from orderList
  //         if (unsavedOrderToCheck) {
  //           console.log('Status of Unsaved Order:', unsavedOrderToCheck.status);
  //           if (unsavedOrderToCheck.status === 'ticketGenerated') {
  //             this.orderList = this.orderList.filter(order => order.id !== this.orderId);
  //             console.log('Order was removed from the list');
  //           } else {
  //             console.log('Order not removed; status is not ticketGenerated');
  //           }
  //         } else {
  //           console.log('No matching unsaved order found');
  //         }
  //       }
  
  //       this._totalItems = this.orderList.length; // Update the totalItems
  
  //       // Trigger change detection
  //       this.cdr.detectChanges();
  //       console.log('Final Order List:', this.orderList);
  //     },
  //     (err: any) => {
  //       console.log('Error fetching orders:', err);
  //     }
  //   );
  // }
  
  
  
  
  
  


// updateOrder(orderId: string) {
    //   this.jss.getJssById(orderId).subscribe(
    //     (res: any) => {
    //       this.unsavedOrderForm.patchValue({
    //         jssId:res._id,
    //         clientName: res.clientName,
    //         ticketno: res.ticketno,
    //         poNo: res.poNo,
    //         refNo: res.refNo,
    //         created: this.formatDate(res.created),
    //         jobName:res.jobName ,
    //         LamType:res.LamType ,
    //         jobType:res.jobType ,
    //         orderKgs :res.orderKgs,
    //         jssfolderno: res.jssfolderno,
    //         std: res.std,
    //         location: res.cylinders.location,
    //         length: res.cylinders.length,
    //         circumference: res.cylinders.circumference,
    //         id: res.cylinders.id,
    //         supplier: res.cylinders.supplier,
    //         coilWidth:res.coilWidth,
    //         coreType:res.coreType,
    //         repeatLength:res.repeatLength,
    //         coilod:res.coilod,
    //         pouch:res.pouch,
    //         barcode:res.barcode,
    //         liquid:res.liquid,
    //         inkType:res.inkType,
    //         fdOption:res.fdOption,
    //         packageType:res.packageType,
    //         remark:res.remark,
    //         colorNames:res.colorNames,
    //         colorNumber:res.colorNumber,
    //         printType:res.printType,
    //         printDirection:res.printDirection,
    //       });
          
         
            
    //     },
    //     (err: any) => {
    //       console.log(err);
    //     }
    //   );
    // }
    
    // getMat(orderId: string) {
    //   this.matMixService.getAllMatMix().subscribe(
    //     (res: any[]) => {
    //       console.log(res);
          
    //       // Find the object with the matching orderId
    //       const orderDetails = res.find(item => item.orderId === orderId);
          
    //       if (orderDetails) {
    //         console.log('Order Details:', orderDetails);
            
    //         // Iterate through matArray and patch the form
    //         orderDetails.matArray.forEach((item:any, index:any) => {
    //           const controlPrefix = index + 1; // To match form control names (1-based index)
    
    //           this.unsavedOrderForm.patchValue({
    //             [`material${controlPrefix}`]: item.materialMix,
    //             [`matSize${controlPrefix}`]: item.matSize,
    //             [`matReq${controlPrefix}`]: item.matRequired
    //           });
    //         });
            
    //         // Optionally, you can also update other form fields if needed
    //         this.unsavedOrderForm.patchValue({
    //           // Additional fields to update if required
    //         });
            
    //       } else {
    //         console.log('Order not found');
    //       }
          
    //       // Trigger change detection after updating form values
    //       this.cdr.detectChanges();
    //     },
    //     (err: any) => {
    //       console.error('Error fetching matArray:', err);
    //     }
    //   );
    // }



// getConfirmedOrders() {
//   const jssCreatedOrders$ = this.jss.getJssList();
//   const existingOrders$ = this.repeated.getAllRepeatOrder();

//   forkJoin([jssCreatedOrders$, existingOrders$]).subscribe(
//     ([jssCreatedOrders, existingOrders]: [any[], any[]]) => {
//       // Combine all orders
//       this.allOrders = [
//         ...jssCreatedOrders.filter((order: any) => 
//           order.status === 'JssCreated' && !order.date1 && !order.prepared && !order.approved
//         ),
//         ...existingOrders.filter((order: any) => 
//           order.status === 'Repeated Order' && !order.date1 && !order.prepared && !order.approved
//         )
//       ];

//       // By default, show only JssCreated orders in reverse order
//       this.orderList = [...this.allOrders.filter(order => order.status === 'JssCreated')].reverse();
//       this.FullorderList = [...this.allOrders].reverse();

//       // Check if the order with orderId has the status 'TickGenerate'
//       if (this.orderId) {
//         const orderToCheck = this.allOrders.find(order => order.id === this.orderId);
//         if (orderToCheck && orderToCheck.status === 'ticketGenerated') {
//           // Remove this order from orderList
//           this.orderList = this.orderList.filter(order => order.id !== this.orderId);
//         }
//       }

//       this._totalItems = this.orderList.length; // Update the totalItems

//       this.cdr.detectChanges();
//     },
//     (err: any) => {
//       console.log('Error fetching orders:', err);
//     }
//   );
// }

    // getMat(orderId: string) {
    //   // Fetch matMix data
    //   this.matMixService.getAllMatMix().subscribe(
    //     (matMixResponse: any[]) => {
    //       console.log('MatMix Response:', matMixResponse);
    
    //       // Find the object with the matching orderId in matMixResponse
    //       const orderDetails = matMixResponse.find(item => item.orderId === orderId);
    
    //       if (orderDetails) {
    //         console.log('Order Details:', orderDetails);
    
    //         // Iterate through matArray and patch the form with materialMix values
    //         orderDetails.matArray.forEach((item: any, index: any) => {
    //           const controlPrefix = index + 1; // To match form control names (1-based index)
    
    //           this.unsavedOrderForm.patchValue({
    //             [`material${controlPrefix}`]: item.materialMix,
    //             [`matSize${controlPrefix}`]: item.matSize,
    //             [`matReq${controlPrefix}`]: item.matRequired
    //           });
    
    //           console.log(`Updated material${controlPrefix}:`, item.materialMix);
    
    //           // Now fetch matAllot data for the corresponding materialMix
    //           this.matAllotService.getAllMatAllot().subscribe(
    //             (matAllotResponse: any[]) => {
    //               console.log('MatAllot Response:', matAllotResponse);
    
    //               // Find the object with the matching orderId in matAllotResponse
    //               const orderAllotDetails = matAllotResponse.find(item => item.orderId === orderId);
    
    //               if (orderAllotDetails) {
    //                 console.log('Order Details matAllot:', orderAllotDetails);
    
    //                 // Find the process for the current materialMix
    //                 const matchingProcessItem = orderAllotDetails.materialProcesses.find(processItem => processItem.material === item.materialMix);
    
    //                 if (matchingProcessItem) {
    //                   // Update form fields with process information
    //                   this.unsavedOrderForm.patchValue({
    //                     [`processFor${item.materialMix}`]: matchingProcessItem.process,
    //                     // Add other form fields as needed
    //                   });
    
    //                   console.log(`Updated processFor${item.materialMix}:`, matchingProcessItem.process);
    //                 } else {
    //                   console.log(`Process not found for materialMix ${item.materialMix}`);
    //                 }
    
    //                 // Trigger change detection after updating form values
    //                 this.cdr.detectChanges();
    //               } else {
    //                 console.log('Order not found in matAllot');
    //               }
    //             },
    //             (err: any) => {
    //               console.error('Error fetching matAllot:', err);
    //               // Handle error - for example, show a toast or message to the user
    //             }
    //           );
    //         });
    
    //       } else {
    //         console.log('Order not found in matMix');
    //       }
    //     },
    //     (err: any) => {
    //       console.error('Error fetching matMix:', err);
    //       // Handle error - for example, show a toast or message to the user
    //     }
    //   );
    // }



  //   getMat(orderId: string) {
  //     // Fetch matMix data
  //     this.matMixService.getAllMatMix().subscribe(
  //         (matMixResponse: any[]) => {
  //             console.log('MatMix Response:', matMixResponse);
  
  //             // Find the object with the matching orderId in matMixResponse
  //             const orderDetails = matMixResponse.find(item => item.orderId === orderId);
  
  //             if (orderDetails) {
  //                 console.log('Order Details:', orderDetails);
  
  //                 // Initialize an array to hold the updated materials array
  //                 const updatedMaterialsArray = [];
  
  //                 // Fetch matAllot data to get processes for all materials
  //                 this.matAllotService.getAllMatAllot().subscribe(
  //                     (matAllotResponse: any[]) => {
  //                         console.log('MatAllot Response:', matAllotResponse);
  
  //                         // Find the object with the matching orderId in matAllotResponse
  //                         const orderAllotDetails = matAllotResponse.find(item => item.orderId === orderId);
  
  //                         if (orderAllotDetails) {
  //                             console.log('Order Details matAllot:', orderAllotDetails);
  
  //                             // Combine Materials and exMaterials
  //                             const combinedMaterials = [
  //                                 ...orderDetails.Materials,
  //                                 ...orderDetails.exMaterials.map((item: any) => ({
  //                                     material: item.extMat,
  //                                     matSize: item.thickness+'x'+item.width,
  //                                     matRequired: item.matRequired
  //                                 }))
  //                             ];
  
  //                             // Process each combined material
  //                             combinedMaterials.forEach((item: any, index: number) => {
  //                                 // Find the matching process for the current material
  //                                 const matchingProcessItem = orderAllotDetails.materialProcesses.find((processItem :any) => processItem.material === item.material);
  
  //                                 if (matchingProcessItem) {
  //                                     // Update materials array item with process
  //                                     const updatedItem = {
  //                                         materialMix: item.material,
  //                                         matSize: item.thickness+'x'+item.width,
  //                                         matRequired: item.matRequired,
  //                                         process: matchingProcessItem.process
  //                                     };
  //                                     updatedMaterialsArray.push(updatedItem);
  
  //                                     // Update form fields for the current material item
  //                                     this.unsavedOrderForm.patchValue({
  //                                         [`material${index + 1}`]: updatedItem.materialMix,
  //                                         [`matSize${index + 1}`]: updatedItem.matSize,
  //                                         [`matReq${index + 1}`]: updatedItem.matRequired,
  //                                         [`Process${index + 1}`]: updatedItem.process,
  //                                         // Add other form fields as needed
  //                                     });
  
  //                                     console.log(`Updated materials item ${index + 1} with process:`, updatedItem.process);
  //                                 } else {
  //                                     console.log(`Process not found for material ${item.material}`);
  //                                 }
  //                             });
  
  //                             // Update orderDetails with updated materials array
  //                             orderDetails.Materials = updatedMaterialsArray;
  //                             console.log('Updated materials array:', updatedMaterialsArray);
  
  //                             // Trigger change detection after updating form values and materials array
  //                             this.cdr.detectChanges();
  //                         } else {
  //                             console.log('Order not found in matAllot');
  //                         }
  //                     },
  //                     (err: any) => {
  //                         console.error('Error fetching matAllot:', err);
  //                         // Handle error - for example, show a toast or message to the user
  //                     }
  //                 );
  
  //             } else {
  //                 console.log('Order not found in matMix');
  //             }
  //         },
  //         (err: any) => {
  //             console.error('Error fetching matMix:', err);
  //             // Handle error - for example, show a toast or message to the user
  //         }
  //     );
  // }
  
// getConfirmedOrders() {
//   // Fetch orders from both services
//   const jssCreatedOrders$ = this.jss.getJssList();
//   const existingOrders$ = this.repeated.getAllRepeatOrder();

//   // Use forkJoin to wait for both observables to complete
//   forkJoin([jssCreatedOrders$, existingOrders$]).subscribe(
//     ([jssCreatedOrders, existingOrders]: [any[], any[]]) => {
//       // Combine both lists
//       const combinedOrders = [
//         ...jssCreatedOrders.filter((order: any) => order.status === 'JssCreated'),
//         ...existingOrders.filter((order: any) => order.status === 'Repeated Order')
//       ];

//       // Optionally reverse the list
//       this.orderList = combinedOrders.reverse();

//       // Trigger change detection
//       this.cdr.detectChanges();
//     },
//     (err: any) => {
//       console.log('Error fetching orders:', err);
//     }
//   );
// }
    // getConfirmedOrders() {
    //   this.jss.getJssList().subscribe(
    //     (res: any) => {
    //       // Filter only orders with status 'reconfirmed'
    //       this.orderList = res.filter((order:any) => order.status === 'JssCreated');
    //       this.orderList.reverse();
    //       this.cdr.detectChanges(); // Trigger change detection
    //     },
    //     (err: any) => {
    //       console.log(err);
    //     }
    //   );
    // }
    
  //    getConfirmedOrders() {
  //   this.orderService.getConfirmedOrders().subscribe(
  //     (res: any) => {
  //       // Filter only confirmed orders
  //       this.orderList = res.filter(order => order.isConfirmed);
  //       this.cdr.detectChanges(); // Trigger change detection
  //     },
  //     (err: any) => {
  //       console.log(err);
  //     }
  //   );
  // }
   
  // fetchJssDetails(orderId: string) {
  //   this.jss.getJssList().subscribe(
  //     (jssList: any[]) => {
  //       console.log('JSS List:', jssList); // Check if you are receiving the JSS list
  //       const jssEntry = jssList.find(jss => jss.id === orderId && jss.status === 'JssCreated');
  //       if (jssEntry) {
  //         console.log('Found JSS Entry:', jssEntry); // Check the found JSS entry
  //         // Update jssfolderno in unsavedOrderForm location
  //         this.unsavedOrderForm.patchValue({
  //           jssfolderno: jssEntry.jssfolderno,
  //         });
  //       } else {
  //         console.log(`JSS entry not found for orderId: ${orderId}`);
  //       }
  //     },
  //     (err: any) => {
  //       console.error('Error fetching JSS list:', err);
  //     }
  //   );
  // }